import { render, staticRenderFns } from "./NotToJoinTheGroup.vue?vue&type=template&id=2239f643"
import script from "./NotToJoinTheGroup.vue?vue&type=script&lang=js"
export * from "./NotToJoinTheGroup.vue?vue&type=script&lang=js"
import style0 from "./NotToJoinTheGroup.vue?vue&type=style&index=0&id=2239f643&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports